<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2 form-horizontal">
    <div class="form-group row">
        <div class="col-md-12">
            <yt-input
                [Type]="'text'"
                name="txtNaziv"
                formControlName="Naziv"
                #focusElement
                [MaxLength]="50"
                [ngClass]="{'is-invalid' : submitted && fc.Naziv.invalid}"
                [Label]="'VELICINASET.VRSTA.SINGULAR'">
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
            <span *ngFor="let validation of errorMessages.Naziv">
                <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
            </span>              
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-md-12">
            <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[0]" [ParentPropertyName]="'VelicinaSetID'" [ParentPropertyValue]="Item.ID" [Disabled]="!Item.ID || Item.ID<=0" [Parameters]="modelData.MainList.GetParameters"></yt-fw-default-detail-list-modal>
        </div>
    </div>
            

</form>